<script setup>
  import { useBrandChannelStore } from '../../store';

  const brandChannelStore = useBrandChannelStore();

  const logo = brandChannelStore.tape.brand_channel.logo
  const clientName = brandChannelStore.tape.brand_channel.client_name
  const headerColor = brandChannelStore.tape.brand_channel.header_color

</script>

<template>
  <header class="header" :style="{ backgroundColor: headerColor }">
    <div class="container">
      <h1 class="header__logo" :style="{ backgroundImage: `url(${logo})` }">{{ clientName }}</h1>
    </div>
  </header>
</template>

<style>
.header {
  padding: 10px 0;
  overflow: hidden;
}

.header__logo {
  float: left;
  height: 32px;
  width: 120px;
  text-indent: -9999px;
  background-position: center left;
  background-repeat: no-repeat;
  background-size: contain;
}
</style>
